export default {
  createStudyMaterial: "/studyMaterial/createStudyMaterial",
  bulkCreateStudyMaterial: "/studyMaterial/bulkCreateStudyMaterial",
  getStudyMaterial: "/studyMaterial/getStudyMaterial",
  editStudyMaterial: "/studyMaterial/editStudyMaterial",
  deleteStudyMaterial: "/studyMaterial/deleteStudyMaterial",
  getSignedUrl: "/spaces/presigned_url"
};
